"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _TemplateMessageHelpers = require("./TemplateMessageHelpers");

var _TemplateMessageInsertTag = _interopRequireDefault(require("./TemplateMessageInsertTag"));

/**
 * @typedef TemplateTag
 * @property {string} placeholder
 * @property {string} label
 * @property {string} [value='']
 */

/**
 * TemplateMessageEditor.
 *
 * @param {object} props
 * @param {string} [props.value]
 * @param {string} [props.label]
 * @param {string} [props.error='']
 * @param {number} [props.minRows]
 * @param {function (string): void} props.onChange
 * @param {Array<TemplateTag>} props.tags
 * @param {number} props.charsLimit
 * @param {string} props.shadowText
 * @param {boolean} props.disabled
 * @param {function (string): void} props.onInsert
 * @param props.hide
 * @returns {React.ReactNode}
 * @example
 * export const AwesomeMessage = () => {
 *  const [value, setValue] = useState('Hello my dear friend {contact-name}');
 *  const tags = [
 *    { placeholder: '{contact-name}', value: 'Benedikt', label: 'Contact name' }
 *  ];
 *  return (
 *    <TemplateMessageEditor
 *      value={value}
 *      onChange={setValue}
 *      error={'Please remove placeholders'}
 *      tags={tags}
 *      charsLimit={1000}
 *    />
 *  );
 * }
 */
var TemplateMessageEditor = function TemplateMessageEditor(_ref) {
  var value = _ref.value,
      label = _ref.label,
      shadowText = _ref.shadowText,
      error = _ref.error,
      onChange = _ref.onChange,
      minRows = _ref.minRows,
      onInsert = _ref.onInsert,
      tags = _ref.tags,
      charsLimit = _ref.charsLimit,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$hide = _ref.hide,
      hide = _ref$hide === void 0 ? false : _ref$hide,
      textFieldProps = (0, _objectWithoutProperties2["default"])(_ref, ["value", "label", "shadowText", "error", "onChange", "minRows", "onInsert", "tags", "charsLimit", "disabled", "hide"]);
  var textFieldRef = (0, _react.useRef)(null);
  var onInsertTag = (0, _react.useCallback)(function (tag) {
    var _textFieldRef$current = textFieldRef.current,
        selectionStart = _textFieldRef$current.selectionStart,
        selectionEnd = _textFieldRef$current.selectionEnd,
        refValue = _textFieldRef$current.value;
    var shadowSelectionStart = (0, _TemplateMessageHelpers.getShadowTextCursorPosition)(shadowText, refValue, selectionStart);
    var shadowSelectionEnd = (0, _TemplateMessageHelpers.getShadowTextCursorPosition)(shadowText, refValue, selectionEnd);
    var shadowFirstPart = shadowText.substring(0, shadowSelectionStart);
    var shadowLastPart = shadowText.slice(shadowSelectionEnd, shadowText.length);
    onInsert("".concat(shadowFirstPart, "[").concat(tag.placeholder, "]").concat(shadowLastPart));
    setTimeout(function () {
      textFieldRef.current.selectionStart = selectionStart + tag.value.length;
      textFieldRef.current.selectionEnd = selectionEnd + tag.value.length;
      textFieldRef.current.focus();
    }, 100);
  }, [onInsert, shadowText]);
  var handleChange = (0, _react.useCallback)(function (_ref2) {
    var currentTarget = _ref2.currentTarget;
    onChange(currentTarget.value);
  }, [onChange]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !hide && /*#__PURE__*/_react["default"].createElement(_material.Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end"
  }, /*#__PURE__*/_react["default"].createElement(_TemplateMessageInsertTag["default"], {
    disabled: disabled,
    inputRef: textFieldRef,
    onInsert: onInsertTag,
    tags: tags
  })), /*#__PURE__*/_react["default"].createElement(_material.TextField, (0, _extends2["default"])({
    fullWidth: true,
    multiline: true,
    error: !!error,
    minRows: minRows,
    label: label,
    variant: "outlined",
    value: value,
    onChange: handleChange,
    inputRef: textFieldRef,
    disabled: disabled,
    FormHelperTextProps: (0, _react.useMemo)(function () {
      return {
        component: 'div'
      };
    }, []),
    helperText: /*#__PURE__*/_react["default"].createElement(_material.Box, {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      width: 1
    }, /*#__PURE__*/_react["default"].createElement(_material.Box, null, error), /*#__PURE__*/_react["default"].createElement(_material.Box, {
      color: "text.primary"
    }, value.length, "/", charsLimit))
  }, textFieldProps)));
};

TemplateMessageEditor.propTypes = {
  onChange: _propTypes["default"].func.isRequired,
  onInsert: _propTypes["default"].func.isRequired,
  shadowText: _propTypes["default"].string.isRequired,
  value: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].string,
  error: _propTypes["default"].string,
  minRows: _propTypes["default"].number,
  tags: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    placeholder: _propTypes["default"].string.isRequired,
    label: _propTypes["default"].string.isRequired,
    value: _propTypes["default"].string
  })).isRequired,
  charsLimit: _propTypes["default"].node.isRequired,
  disabled: _propTypes["default"].bool,
  hide: _propTypes["default"].bool
};
TemplateMessageEditor.defaultProps = {
  minRows: 1,
  label: 'Your message',
  error: '',
  disabled: false,
  hide: false
};

var _default = /*#__PURE__*/(0, _react.memo)(TemplateMessageEditor);

exports["default"] = _default;